module.exports = __webpack_public_path__ + "img/utility-impostor-figure.74bf8696.webp";